import React from 'react';
import Grid from "@material-ui/core/Grid";
import Slider from "react-slick";
import Hidden from "@material-ui/core/Hidden";

// images
import Quotation from '../../images/quotation-marks.png';
import next from '../../images/icon/next.png';
import prev from '../../images/icon/prev.png';

import './style.scss';


function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
        <img
            src={next}
            className={className}
            style={{ ...style, display: "inline-block" }}
            onClick={onClick}
            alt="next"
        />
    );
}

function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
        <img
            src={prev}
            className={className}
            style={{ ...style, display: "inline-block" }}
            onClick={onClick}
            alt="prev"
        />
    );
}

const settings = {
    dots:false,
    infinite: true,
    arrows: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />
};

const testimonials = [
    {
        id: 1,
        name: 'Indra David',
        profession: 'Boutique Owner',
        body: 'One of my staff members requested a pay stub and I was so grateful I came across OneTwoPay. It’s so easy to use, I bought an annual subscription and I use it every month, even as my team continues to grow.'
    },
    {
        id: 2,
        name: 'David Bowie ',
        profession: 'Musician',
        body: 'We have a small band you likely never heard of, but when we tour we have a rodie with us and needed to create PayStubs for him' 
    },
    {
        id: 3,
        name: 'Larry David',
        profession: 'Almost a David',
        body: 'Nam quis laoreet nisl. Vivamus nec quam magna. Cras interdum metus blandit hendrerit ornare. Sed id leo nulla. Etiam ornare imperdiet ligula, sit amet gravida felis bibendum eget. Lorem ipsum dolor sit amet.'
    },
];

const TestimonialCarousel = () => {
    return(
        <Grid className="testimonialCarousel">
            <Grid container className="container">
                <Hidden smDown><Grid item md={1}/></Hidden>
                <Grid item xs={12} md={10}>
                    <Slider {...settings}>
                        {testimonials.map(item => {
                            return (
                                <Grid key={item.id} className="tstItem">
                                    <p><img src={Quotation} alt=""/>{item.body}</p>
                                    <Grid className="tstAuthor">
                                        <h4>{item.name}</h4>
                                        <strong>{item.profession}</strong>
                                    </Grid>
                                </Grid>

                            )
                        })}
                    </Slider>
                </Grid>
            </Grid>
        </Grid>
    )
};

export default TestimonialCarousel;